import { nanoid } from 'nanoid';
import { useCallback, useState } from 'react';

export default function useRandomKey() {
  const [state, setState] = useState<string>(nanoid());
  return [state, useCallback(() => setState(nanoid()), [])] as const;
}
